export enum StateVariableNames {
  AVATAR = 'avatar',
  ONLY_CHECKBOX_CHAT_OPTIONS = 'only_checkbox_chat_options',
}
